export default {
  'zh': '简体中文',
  'en': 'English',
  'vi': 'Tiếng Việt',
  'ru': 'Русский язык'
};